import { gql, useQuery } from "@apollo/client";

export default function useFtpConnections() {
  const { loading, error, data, refetch } = useQuery(
    gql`
      query {
        getFtpConnections {
          id
          clientName
          host
          port
          username
          password
          filePrefix
          privateKey
          status
        }
      }
    `,
    {
      onError: (error) => {
        console.error("GraphQL error: ", error.message);
      },
    }
  );
  const defaultFtpConnectionData = [
    {
      id: 0,
      clientName: "Default Connection",
      host: "",
      port: 21,
      username: "",
      password: "",
      filePrefix: "",
      privateKey: "",
      status: "Disabled",
    },
  ];

  const refetchData = () => {
    refetch().catch((error) => {
      console.error("Refetch error: ", error.message);
      // Handle refetch error
    });
  };

  if (loading) {
    console.log("Loading FTP connections...");
    return {
      loading,
      error: null,
      data: defaultFtpConnectionData,
      refetch: refetchData,
    };
  }

  if (error) {
    console.error("GraphQL error: ", error.message);
    return {
      loading: false,
      error,
      data: defaultFtpConnectionData,
      refetch: refetchData,
    };
  }

  return {
    loading,
    error,
    data: data?.getFtpConnections || [],
    refetch: refetchData,
  };
}
